import { BASE_URL } from '../config';
import axiosApiInstance from '../../interceptors/axiosApiInstance';

const NotificationService = {
    getNotifications: async function (unread) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/notification${unread ? `?unRead=${unread}` : ''}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    changeReadStatus: async function (data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + '/notification/change-read-status', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteSelectedNotifications: async function (data) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + '/notification', { data: data });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};
export default NotificationService;
